<template>
  <b-modal id="groupLeaveTypesModal" :title="group.name ? `Leave Types - ${group.name}` : 'Leave Types'" size="lg" hide-footer no-close-on-backdrop scrollable @hidden="isEditing = false">

    <!-- <div class="my-2">
      <button class="btn btn-primary" @click="startEdit" v-if="!isEditing">Edit Limits</button>
    </div> -->

    <table class="table table-striped table-bordered" v-if="!isEditing">
      <thead class="thead-dark text-left">
        <th style="width:1%;white-space:nowrap">Sl No.</th>
        <th>Leave Type</th>
        <th>Limit</th>
      </thead>
      <tbody>
        <tr v-if="leaveTypes.length === 0">
          <td colspan="3" class="text-center">No leave types found</td>
        </tr>
        <tr v-for="(item, index) in leaveTypes" :key="item.id">
          <td>{{ index + 1 }}</td>
          <td>{{ item.leave_type.name }}</td>
          <td>{{ item.is_unlimited ? 'NA' : item.max_leaves }}</td>
        </tr>
      </tbody>
    </table>

    <div v-else>
      <table class="table table-striped table-bordered">
        <thead class="thead-dark text-left">
          <th>Leave Type</th>
          <th>Limit</th>
        </thead>
        <tbody>
          <tr v-for="item in editLimits" :key="item.id">
            <td>{{ item.name }}</td>
            <td>
              <b-form-input
                v-model.number="item.limit"
                type="number"
                min="0"
                style="width: 80px"
              ></b-form-input>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-between mt-2">
        <button class="btn btn-primary" @click="saveLimits" :disabled="saving">Submit</button>
        <button class="btn btn-danger" @click="isEditing = false">Cancel</button>
      </div>
    </div>

  </b-modal>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    leaveTypes: {
      type: Array,
      default: () => [],
    },
    group: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isEditing: false,
      saving: false,
      editLimits: [],
    };
  },

  methods: {
    startEdit() {
      this.editLimits = this.leaveTypes.map((item) => ({
        id: item.id,
        name: item.name,
        limit: item.pivot ? item.pivot.limit : item.limit,
      }));
      this.isEditing = true;
    },

    async saveLimits() {
      this.saving = true;

      const leave_limits = {};
      this.editLimits.forEach((item) => {
        leave_limits[item.id] = item.limit;
      });

      const url = this.$store.getters.getAPIKey.mainAPI + `/faculty-leave/group/leave-limits`;

      await axios
        .post(url, {
          leave_group_id: this.group.id,
          leave_cycle_id: this.group.leave_cycle_id,
          leave_limits,
        })
        .then(() => {
          this.$toast.success("Leave limits updated", {
            position: "top",
            duration: 3000,
          });
          this.isEditing = false;
          this.$emit("updated");
        })
        .catch(() => {
          this.$toast.error("Failed to update leave limits", {
            position: "top",
            duration: 3000,
          });
        });

      this.saving = false;
    },
  },
};
</script>
